import { createSlice } from '@reduxjs/toolkit';
import { AsyncState } from '../types';
import { ProfitCenterApi, ProfitCenterDto } from '../../http';
import { FindAllResponse } from '../../http/types';
import { createFetchAsync } from '../slice.utils';

const profitCenterApi = new ProfitCenterApi();

export const fetchProfitCenterAsync = createFetchAsync(
  'profitCenter',
  'findAll',
  async (params, { rejectWithValue }) => {
    try {
      return await profitCenterApi.findAll({ limit: 1000, ...params });
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const forceFetchProfitCenter = fetchProfitCenterAsync.asyncThunk;

export const fetchProfitCenter = (payload) => (dispatch, getState) => {
  const {
    profitCenter: { findAll }
  } = getState();

  if (!findAll.payload && findAll.loading == false) {
    dispatch(forceFetchProfitCenter(payload));
  }
};

type ProfitCenterState = {
  findAll: AsyncState<FindAllResponse<ProfitCenterDto>>;
};

const initialState: ProfitCenterState = {
  findAll: fetchProfitCenterAsync.initialState
};

const profitCenter = createSlice({
  name: 'profitCenter',
  initialState,
  reducers: {},
  extraReducers: {
    ...fetchProfitCenterAsync.extraReducers
  }
});

export default profitCenter.reducer;
